var _rect, _line, _line2, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQualityCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 18.5,
    height: 22.7857,
    stroke: "black",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.57031,
    y1: 13.8574,
    x2: 16.7132,
    y2: 13.8574,
    stroke: "#1A4B72",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.57031,
    y1: 18.1426,
    x2: 16.7132,
    y2: 18.1426,
    stroke: "#1A4B72",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2315_3457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.16668 12.25L4.87501 14.5417L3.83334 13.5",
    stroke: "#1A4B72",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 4.5,
    width: 13,
    height: 5,
    fill: "#1A4B72",
    stroke: "#1A4B72"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2315_3457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    fill: "white",
    transform: "translate(3 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityCheck);
export default __webpack_public_path__ + "static/media/QualityCheck.6048c2dd1e7b3cc282912d716384ffc6.svg";
export { ForwardRef as ReactComponent };